import React from 'react'
import { Button, Form, Radio } from 'semantic-ui-react'
import ResponsiveDateInput from '../componentsHelpers/ResponsiveDateInput';

import styled from "styled-components";
import { ErrorMessage } from "formik";

const RedText = styled.p`
  color: red;
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

class WorkFormB extends React.Component<any, any> {

    next = (e: any) => {
        e.preventDefault();
        this.props.gaEvent('event', 'InitialCriteria', 'Next', 'Boots', this.props.isValid);
        this.props.nextStep(this.props);
    }

    renderDateField(dateTypeName: string, dateTypeVal: string) {
        /* conditionally render the date field */
        if (this.props.values[dateTypeName] === dateTypeVal) {
            return (
                <Form.Group grouped>
                    <React.Fragment>
                    <ResponsiveDateInput
                    isMobile={(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))}
                    name={dateTypeVal === 'yes' ? 'stp2_startDate' : 'stp2_endDate'}
                    label={dateTypeVal === 'yes' ? 'Start Date' : 'End Date'}
                    id={dateTypeVal === 'yes' ? "stp2_startDate" : "stp2_endDate"}
                    setFieldValue={this.props.setFieldValue}  
                    values={this.props.values}
                    dataTestid={dateTypeVal === 'yes' ? 'wfb-start-date-input' : 'wfb-end-date-input'}
                    />
                    </React.Fragment>
                    <ErrorMessage
                        name={dateTypeVal === 'yes' ? 'stp2_startDate' : 'stp2_endDate'}
                        render={msg => <RedText className="error"> {msg} </RedText>}
                    />
                </Form.Group>
            );
        }
    }

    renderAdditionalFields() {
        if (this.props.values.stp1_worked === 'yes') {
            return (
                <Form.Group grouped>
                    <label>Do you still work at Boots?</label>
                    <Form.Field>
                        <Radio
                            label='Yes'
                            name='stp2_stillWorkThere'
                            value='yes'
                            checked={this.props.values.stp2_stillWorkThere === 'yes'}
                            onChange={() => {
                                this.props.setFieldValue("stp2_endDate", "");
                                this.props.setFieldValue("stp2_stillWorkThere", "yes");
                            }
                            }
                            data-testid='wfb-radio-yes'
                        />
                    </Form.Field>
                    <Form.Field>
                        <Radio
                            label='No'
                            name='stp2_stillWorkThere'
                            value='no'
                            checked={this.props.values.stp2_stillWorkThere === 'no'}
                            onChange={() => this.props.setFieldValue("stp2_stillWorkThere", "no")}
                            data-testid='wfb-radio-no'
                        />
                    </Form.Field>
                    <Form.Field>
                        <Radio
                            label='Yes, but I am working a notice period'
                            name='stp2_stillWorkThere'
                            value='notice-period'
                            checked={this.props.values.stp2_stillWorkThere === 'notice-period'}
                            onChange={() => {
                                this.props.setFieldValue("stp2_endDate", "");
                                this.props.setFieldValue("stp2_stillWorkThere", "notice-period")
                            }
                            }
                            data-testid='wfb-radio-notice'
                        />
                    </Form.Field>
                    <ErrorMessage
                        name={'stp2_stillWorkThere'}
                        render={msg => <RedText className="error"> {msg} </RedText>}
                    />
                </Form.Group>
            );
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.renderDateField('stp1_worked', 'yes')}
                {this.renderAdditionalFields()}
                {this.renderDateField('stp2_stillWorkThere', 'no')}

                <Button.Group widths="2">
                    <Button labelPosition='right' floated='right' color={this.props.isValid ? 'green' : 'grey'} icon='right chevron' content='Next' onClick={this.next} data-testid='wfb-button' />
                </Button.Group>

            </React.Fragment>
        )
    }
}

export default WorkFormB;